import React from "react";
import { connect } from "react-redux";
import { finalizarPlanMovilidad, changeSubMenu } from "../actions";
import Loading from "../../Util/Loading";
import KitSeguimientoPlanMovilidad from "./kit";
import { scrollElementToTop } from "../functions";

class MainSeguimientoPlanMovilidad extends React.PureComponent {

  componentDidMount = () => {
    scrollElementToTop("mainContent");
  }

  render() {
    return (
      <div id="seguimiento_plan_movilidad">
        { this.props.isMedidasLoading && <Loading /> }
        <section id="content-etapa">
          <div className="container-fluid">
            <div className="row PM-plan-borde-spacing">
              <div className="col-md-12 text-center PM-tipo-denuncias-select">
                <div className="row col-md-12 text-center">
                  <div className="PM-section-title col-md-12 text-center">Para ejecutar el plan de movilidad Traslado Seguro,</div>
                  <div className="col-md-12 text-center"><h5>realiza las siguientes tareas:</h5></div>
                </div>
              </div>
              <div className="col-md-12 text-center PM-plan-contador-tareas PM-home-item-plan">
                <ul>
                  <li className="PM-border-line">
                    <div className="row">
                      <div className="col-sm-9 text-left">
                        <div className="PM-cuadro-3">
                          <h5><strong>Accede al detalle de las tareas que involucra cada acción de tu plan de movilidad.</strong></h5>
                        </div>
                      </div>
                      <div className="col-sm-3 btn-material">
                        <button
                          className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-button-light"
                          onClick={() => { this.props.dispatch(changeSubMenu(1)); }}
                          disabled={this.props.estadoProceso !== 4}
                        >Acciones</button>
                      </div>
                    </div>
                  </li>
                  <li className="PM-border-line">
                    <div className="row">
                      <div className="col-sm-9 text-left">
                        <div className="PM-cuadro-3">
                          <p>Notifica en la plataforma la realización de las tareas indicadas.</p>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="PM-border-line">
                    <div className="row">
                      <div className="col-sm-9 text-left">
                        <div className="PM-cuadro-3">
                          <p>Revisa mensualmente el estado de avance del plan de movilidad en la plataforma. Si necesitas replanificar alguna acción, puedes configurar su plazo de ejecución.</p>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="PM-border-line">
                    <div className="row">
                      <div className="col-sm-9 text-left">
                        <div className="PM-cuadro-3">
                          <p>Coordina reuniones trimestrales con el Comité Paritario para informar el estado de avance del plan de movilidad.</p>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="PM-border-line">
                    <KitSeguimientoPlanMovilidad />
                  </li>
                  <li className="PM-border-line">
                    <div className="row">
                      <div className="col-md-8 text-left PM-info">
                        <p>En esta etapa podrás acceder a información sobre los accidentes de trayecto ocurridos durante la ejecución del plan. Para contar con mayor información, completa los datos que te solicitamos.</p>
                      </div>
                      <div className="col-md-4 text-right PM-info">
                        <p><strong>Plazo recomendado:</strong> 12 meses</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="container-fluid PM-btn-box">
            <div className="text-center PM-plan-contador-finalizar">
              <button
                className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-dx-button-plan-aire PM-button-cierre"
                onClick={() => {
                  this.props.dispatch(finalizarPlanMovilidad(this.props.idplanMovilidad));
                }}
                disabled={this.props.estadoProceso !== 4 || !this.props.esEncargado}
              > Siguiente
              </button>
            </div>
          </div>
        </section>
        <div className="PM-footer">&nbsp;</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usuarioRUT: state.global.userData.RUT,
  usuarioNombre: state.global.userData.FirstName,
  usuarioApellido: state.global.userData.LastName,
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  habilitarTokenEncuesta: state.planMovilidad.habilitarTokenEncuesta,
  estadoEjecucion: state.planMovilidad.estadoEjecucion,
  estadoPlan: state.planMovilidad.estadoPlan,
  estadoProceso: state.planMovilidad.estadoProceso,
  estadoEncuestaCentro: state.planMovilidad.estadoEncuestaCentro,
  estadoTokenEncuesta: state.planMovilidad.estadoTokenEncuesta,
  isMedidasLoading: state.planMovilidad.isMedidasLoading,
  listaContenidos: state.planMovilidad.listaContenidos,
  esEncargado: state.planMovilidad.esEncargado,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(MainSeguimientoPlanMovilidad);
